import { InputGroupAddon } from "@src/components/ui/input-group";
import { cn } from "@src/lib/utils";
import type { PromptInputFooterProps } from "./PromptInputFooterProps";

export const PromptInputFooter = ({
  className,
  ...props
}: PromptInputFooterProps) => (
  <InputGroupAddon
    align="block-end"
    className={cn("justify-between gap-1", className)}
    {...props}
  />
);
